import { render, staticRenderFns } from "./ReturnedReport.vue?vue&type=template&id=2fe57d9a&scoped=true"
import script from "./ReturnedReport.vue?vue&type=script&lang=js"
export * from "./ReturnedReport.vue?vue&type=script&lang=js"
import style0 from "./ReturnedReport.vue?vue&type=style&index=0&id=2fe57d9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe57d9a",
  null
  
)

export default component.exports